import { memo } from "react";

import SingleLegalDocument from "./SingleLegalDocument";

function TermsAndConditions() {
   return <SingleLegalDocument document="termsAndConditions" />;
}

export default memo(TermsAndConditions);
